module.exports = __webpack_public_path__ + "img/icon1.cb3047d6.png";